<template>
  <dd-validation-rules-wrapper :name="name" :rules="rules">
    <template #default="validationWrapperProps">
      <validation-provider ref="provider" :name="name" :rules="validationWrapperProps.rules" v-slot="validationProps">
        <dd-input-wrapper
            :rules="validationWrapperProps.rules"
            :title="title"
            :errors="validationProps.errors"
            :name="name"
            :value="value"
            :provider-ref="$refs.provider"
            v-slot="{validateInput}"
        >
          <div :data-dusk="dataDusk" class="flex-row gap-md my-auto switch">
            <a-switch
                :data-dusk="dataDusk"
                :index="title"
                :name="name"
                @blur="validateInput"
                v-model="checkedModel"
                v-bind="$attrs">
              <template #checkedChildren>
                <slot name="checkedChildren">
                </slot>
              </template>
              <template #unCheckedChildren>
                <slot name="unCheckedChildren">
                </slot>
              </template>
            </a-switch>
            <input type="hidden" :value="value" :name="name">
          </div>
        </dd-input-wrapper>
      </validation-provider>
    </template>
  </dd-validation-rules-wrapper>
</template>

<script>
export default {
  name: "DdSwitch",
  emits: ['input'],
  props: {
    dataDusk: String,
    title: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    value: {
      type: [String, Number, Boolean],
      required: false
    },
    rules: {
      type: [String, Array, Object],
      required: false,
    },
    valueAsInt: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    checkedModel: {
      get() {
        if(this.valueAsInt) {
          return this.value === 1 || this.value === '1';
        }
        return this.value === true
      },
      set(value) {
        if(this.valueAsInt) {
          this.$emit('input', value ? 1 : 0);
        } else {
          this.$emit('input', value);
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
// a-switch
.ant-switch-checked {
  background-color: $brand-primary !important;
}
.switch {
  height: 39px;
  display: flex;
  align-items: center;
}
</style>
